import type { ComponentType } from 'react';

import Loadable from 'react-loadable';

import type { HeadlessProbePostOfficePlacementProps } from './HeadlessProbePostOfficePlacement';

export const LoadableHeadlessProbePostOfficePlacement: ComponentType<HeadlessProbePostOfficePlacementProps> =
	Loadable<HeadlessProbePostOfficePlacementProps, never>({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "@atlassian/conversation-assistant-utils/headless-probe-post-office-placement" */ './HeadlessProbePostOfficePlacement'
				)
			).HeadlessProbePostOfficePlacement,
		loading: () => null,
	});

LoadableHeadlessProbePostOfficePlacement.displayName = 'lazy(HeadlessProbePostOfficePlacement)';
